export const amounts = [10, 20, 50];

export const MIN_AMOUNT = 0.1;
export const MAX_AMOUNT = 9_999;
export const PORTMANAT_MAX_AMOUNT = 1_000;
